/**
 * Continue Browsing — remembers the last vehicle the user viewed and the
 * last marketplace search they ran, so the homepage can show a "Continue
 * where you left off" banner on their next visit.
 *
 * Storage is localStorage (per-device, survives close/reopen). Each entry
 * has a timestamp so we can hide it after the value goes stale.
 */
const LAST_VEHICLE_KEY = "cartal:resume:last_vehicle";
const LAST_SEARCH_KEY = "cartal:resume:last_search";
const STALE_MS = 14 * 24 * 60 * 60 * 1000; // 14 days

function safeParse(s) {
  try { return JSON.parse(s); } catch { return null; }
}

export function rememberVehicle(v) {
  if (!v || !v.id) return;
  try {
    localStorage.setItem(
      LAST_VEHICLE_KEY,
      JSON.stringify({
        id: v.id,
        title: `${v.year || ""} ${v.make || ""} ${v.model || ""}`.trim(),
        price_sar: v.price_sar || v.price || null,
        image: (v.images && v.images[0]) || v.image || null,
        city: v.city || null,
        ts: Date.now(),
      })
    );
  } catch { /* localStorage unavailable */ }
}

export function rememberSearch({ pathname, search, label }) {
  if (!pathname) return;
  try {
    localStorage.setItem(
      LAST_SEARCH_KEY,
      JSON.stringify({ pathname, search: search || "", label: label || "", ts: Date.now() })
    );
  } catch { /* ignore */ }
}

function fresh(entry) {
  return entry && entry.ts && Date.now() - entry.ts < STALE_MS;
}

export function getResume() {
  const v = safeParse(localStorage.getItem(LAST_VEHICLE_KEY));
  const s = safeParse(localStorage.getItem(LAST_SEARCH_KEY));
  return {
    vehicle: fresh(v) ? v : null,
    search: fresh(s) ? s : null,
  };
}

export function clearResume() {
  try {
    localStorage.removeItem(LAST_VEHICLE_KEY);
    localStorage.removeItem(LAST_SEARCH_KEY);
  } catch { /* ignore */ }
}
